export default __webpack_public_path__ + "static/media/transfer_navicon-light.20e96f31.svg";